import * as types from './actionTypes';

export const getMasterData = (payload) => {
  return {
    type: types.GET_MASTER_DATA,
    payload,
  };
};
export const setMasterData = (payload) => {
  return {
    type: types.SET_MASTER_DATA,
    payload,
  };
};

export const getKpiData = (payload) => {
  return {
    type: types.GET_KPIS_DATA,
    payload,
  };
};

export const setKpiLoading = (payload) => {
  return {
    type: types.SET_KPI_LOADING,
    payload,
  };
};

export const getPackageList = () => ({
  type: types.GET_PACKAGE_LIST_MASTER,
});

export const setPackageListMaster = (payload) => ({
  type: types.SET_PACKAGE_LIST_MASTER,
  payload,
});

export const setPackageListLoading = (payload) => ({
  type: types.SET_PACKAGE_LIST_LOADING_MASTER,
  payload,
});
